import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";
import { renderStandardPictureElement, getDummyText } from "../../../../utils";
import { renderPageTemplate } from "../../../../utils";

export default {
    title: "MyTrumpf/Page Templates/My Machines/Machine Onboarding",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
};

const Template = () => {
    return html`
        <div class="ux-t-container-full">
            <div class="ux-row">
                ${renderStandardPictureElement({
                    height: 635,
                    width: 1920,
                    isInSlider: false,
                })}
            </div>
        </div>
        <div class="ux-t-container">
            <div class="ux-row">
                <div
                    class="ux-col-12 ux-iws-y-translated-wrapper ux-u-text-align--center"
                >
                    <div
                        class="ux-row ux-u-mt-xxxs ux-u-mt-md-xxs ux-u-mt-xl-xs"
                    >
                        <div class="ux-col-12 ux-col-lg-6 ux-u-offset-lg-3 ">
                            <h1
                                class="ux-text-headline ux-text-headline--giant ux-u-mb-zero"
                            >
                                OPC UA-Schnitstelle für ihre TruMachine 2020
                                (9832937092)
                            </h1>
                        </div>
                    </div>
                    <div class="ux-row">
                        <div class="ux-col-12 ux-col-lg-10 ux-u-offset-lg-1">
                            <p
                                class="ux-text-normal ux-text-normal--light-gray"
                            >
                                ${getDummyText(300)}
                            </p>
                            <p class="ux-text-title-teaser ux-u-mt-xs">
                                ${getDummyText(80)}
                            </p>
                            <p
                                class="ux-text-normal ux-text-normal--light-gray"
                            >
                                ${getDummyText(250)}
                            </p>
                        </div>
                    </div>
                    <div
                        class="ux-button-group ux-button-group--with-spacing ux-u-mt-xs ux-u-mt-md-xxxs"
                    >
                        <a class="ux-button">
                            gesamtlösung finden
                        </a>
                        <a class="ux-button ux-button--green ux-u-mt-xxs">
                            passende schnitstelle finden
                        </a>
                    </div>
                </div>
            </div>
        </div>
    `;
};

export const Default = () => renderPageTemplate(() => Template());
